import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-datepicker/dist/react-datepicker.css';
import '../styles/App.css';
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import TagManager from 'react-gtm-module'
import { ThemeProvider } from '@material-ui/core/styles';
import theme from '../styles/theme'; // Assuming you have a theme file
import ChatwootWidget from '../components/ChatwootWidget.js';
 
const tagManagerArgs = {
    gtmId: 'GTM-M3XT4ZHS'
}

Bugsnag.start({
    apiKey: '52aa566f248f6e725502a68f4215039a',
    plugins: [new BugsnagPluginReact()]
  })

const ErrorBoundary = Bugsnag.getPlugin('react')
.createErrorBoundary(React)

// This default export is required in a new `pages/_app.js` file.
export default function MyApp({ Component, pageProps }) {

    useEffect(() => {
        // Remove the server-side injected CSS.
        const jssStyles = document.querySelector('#jss-server-side');
        if (jssStyles) {
            jssStyles.parentElement.removeChild(jssStyles);
        }

        // Initialize Google Tag Manager
        TagManager.initialize(tagManagerArgs)
        
        // Handle referer redirect with safety checks
        const handleRefererRedirect = async () => {
            const refererItem = localStorage.getItem('referer');
            if (refererItem) {
                // Remove referer first to prevent infinite loops
                window.localStorage.removeItem('referer');
                
                let refererUrl;
                let refererTimestamp;
                
                try {
                    // Try to parse as JSON (new format)
                    const refererData = JSON.parse(refererItem);
                    refererUrl = refererData.url;
                    refererTimestamp = refererData.timestamp;
                } catch (e) {
                    // Fallback to old format (plain URL string)
                    refererUrl = refererItem;
                    refererTimestamp = Date.now(); // Assume it's recent
                }
                
                // Check if referer is too old (more than 10 minutes)
                const maxAge = 10 * 60 * 1000; // 10 minutes
                if (refererTimestamp && (Date.now() - refererTimestamp) > maxAge) {
                    console.log('Referer too old, ignoring redirect');
                    return;
                }
                
                // Only redirect if referer is different from current location
                // and not an auth-related URL
                const currentUrl = window.location.href;
                const isAuthUrl = currentUrl.includes('/api/auth/') || 
                                currentUrl.includes('/login') || 
                                currentUrl.includes('/callback');
                
                if (refererUrl && refererUrl !== currentUrl && !isAuthUrl) {
                    // Add a small delay to ensure app is fully loaded
                    setTimeout(() => {
                        window.location.href = refererUrl;
                    }, 100);
                }
            }
        };
        
        // Only run referer redirect on client-side and after a small delay
        if (typeof window !== 'undefined') {
            setTimeout(handleRefererRedirect, 50);
        }
    }, []);

    return (
    <ErrorBoundary>
        <ThemeProvider theme={theme}>
            <Component {...pageProps }/>
            <ChatwootWidget 
                websiteToken={process.env.NEXT_PUBLIC_CHATWOOT_WEBSITE_TOKEN || ''}
                baseUrl={process.env.NEXT_PUBLIC_CHATWOOT_BASE_URL || ''}
            />
        </ThemeProvider>
    </ErrorBoundary>
    );
}